<main class="grouping-devices-container">
 <div class="grouping-devices">
    <h1 class="main-wrapper"> Group Devices </h1>
    <section [attr.aria-label]="currentStep" class="step-section">
        <div class="main-wrapper">
            <app-stepindicator [stepIndicators]="steps" [displayIndicator]=true [sessionName]="'groupingDevices'"></app-stepindicator>
            <section class="steps-container">
                <div *ngIf="errorMessage.show" class="alert valign-children-middle error-container">
                    <div class="alert-error">
                      <i class="icon-badgealert" role="img" aria-label="Alert" tabindex="0"></i>
                    </div>
                    <div>{{errorMessage.heading}} <span class="message">{{errorMessage.subHeading}}</span></div>
                  </div>
                <router-outlet></router-outlet>
            </section>
        </div>
    </section>
 </div>
</main>

<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
